import { inmunetApi } from '../../../api';

export const enlazarApp = async({ id }) => {

    try {

        const { data } = await inmunetApi.put(`/paciente/enlazar-app/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al enlazar app';

        return data.paciente;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al enlazar app');
        }

    }

};

export const desenlazarApp = async({ id }) => {

    try {

        const { data } = await inmunetApi.put(`/paciente/desenlazar-app/${ id }`);

        if (!data.status) throw (data.msg) ? data.msg : 'Error al desenlazar app';

        return data.paciente;

    } catch (error) {

        if (error.response.data.msg) {
            throw new Error(error.response.data.msg);
        } else {
            throw new Error('Error al desenlazar app');
        }

    }

};